module.exports = __webpack_public_path__ + "img/menu-bar-on_06.3d89fb6e.png";